import { baseURL } from "../../../../../../services/axios";

const LOGO_KEY_PREFIXES = ["LogoLibrary/", "logoLibrary3/"];

const decodePath = (value) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const extractLogoKey = (value) => {
  if (typeof value !== "string" || !value.trim()) return null;
  const candidate = value.trim();
  const direct = decodePath(candidate.split(/[?#]/, 1)[0]).replace(/^\/+/, "");
  const directMatch = LOGO_KEY_PREFIXES.find((prefix) =>
    direct.startsWith(prefix),
  );
  if (directMatch) return direct;

  let parsed;
  try {
    parsed = new URL(candidate);
  } catch {
    return null;
  }

  const pathname = decodePath(parsed.pathname).replace(/^\/+/, "");
  for (const prefix of LOGO_KEY_PREFIXES) {
    const index = pathname.indexOf(prefix);
    if (index >= 0) return pathname.slice(index);
  }
  return null;
};

const getAuthToken = () => {
  const stored = localStorage.getItem("authToken");
  if (!stored) return "";
  try {
    const parsed = JSON.parse(stored);
    return typeof parsed === "string" ? parsed : "";
  } catch {
    return stored;
  }
};

export const getLogoAssetUrl = (logo) => {
  const original = logo?.thumbnail || logo?.url || "";
  const key = [logo?.key, original, logo?.url]
    .map(extractLogoKey)
    .find(Boolean);
  if (!key) return original;

  const params = new URLSearchParams({
    key,
    token: getAuthToken(),
  });
  return `${baseURL}/project/logos/proxy?${params.toString()}`;
};
